export type Iso8601 = string

// Error related types and interfaces
export type ErrorResponse<F extends string = string, S extends string = string, E = undefined> = {
  detail?: string
  message?: string
  errors: Partial<{[key in F]: string}>
  status: S
  extendedData: E
}

export enum ErrorKey {
  ERR_SENSOR_DATA_NOT_AVAILABLE = 'ERR_SENSOR_DATA_NOT_AVAILABLE',
  ERR_DIVISION_BY_ZERO = 'ERR_DIVISION_BY_ZERO',
  ERR_SENSOR_VALUES_EXCEED_THRESHOLD = 'ERR_SENSOR_VALUES_EXCEED_THRESHOLD',
  ERR_FUNCTION_DOES_NOT_EXIST = 'ERR_FUNCTION_DOES_NOT_EXIST',
  ERR_SYNTAX_ERROR = 'ERR_SYNTAX_ERROR',
  ERR_UNSUPPORTED_BINARY_OPERATION = 'ERR_UNSUPPORTED_BINARY_OPERATION',
  ERR_UNSUPPORTED_UNARY_OPERATION = 'ERR_UNSUPPORTED_UNARY_OPERATION',
  ERR_UNDEFINED_VARIABLE_OR_CONSTANT = 'ERR_UNDEFINED_VARIABLE_OR_CONSTANT',
  ERR_INVALID_NUMBER_OF_ARGUMENTS = 'ERR_INVALID_NUMBER_OF_ARGUMENTS'
}

export interface QueryMeta extends Record<string, unknown> {
  errorMessage: string
}

export interface AuditFields {
  createdOn: Iso8601
  createdBy: string
  updatedOn?: Iso8601
  updatedBy?: string
}

export type AutocompleteOption = {id: string; label: string}

export type Nullable<T> = {
  [P in keyof T]: T[P] | null
}
